import React from 'react';

const PageNotFound = () => {
    return (
        <div>
            Page Not Found Click on the Logo or Store name above to return to the Home Page
        </div>
    );
};

export default PageNotFound;